import * as qs from 'query-string'

export const stepRoutesByName = {
  index: '/new-onboarding',
  emailInput: '/new-onboarding/email',
  checkEmail: '/new-onboarding/check-email',
  newUser: '/new-onboarding/user/new',
  returningUser: '/new-onboarding/user/returning',
  options: '/new-onboarding/options',
  loading: '/new-onboarding/loading',
  carriers: '/new-onboarding/carriers',
  unapprovedCarriers: '/new-onboarding/unapproved-carriers',
  noCarriers: '/new-onboarding/no-carriers',
}

// Append optional `token` param to end of route
export const onboardingStepRoutes = Object.values(stepRoutesByName)

type TRouteName = keyof typeof stepRoutesByName

export interface IOnboardingQueryParams {
  token?: string
  /**
   * This type is a per the requirements of `BooleanParam` from our query library.
   * The param in the URL must be 1 or 0, and it is parsed as boolean/undefined.
   */
  mobileApp?: number
}

/**
 * Helper method to get route along with any optional params
 */
export const getRoute = (routeName: TRouteName, params: IOnboardingQueryParams = {}): string => {
  let route = stepRoutesByName[routeName]
  if (Object.keys({ ...params }).length) {
    route += `?${qs.stringify({ ...params })}`
  }
  return route
}
